module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAHlJREFUSEtjnBsj08DIwFjPgAT+M/xvTF7ypAEmhE0NsnpcbJA5jPNiZP9jU5C05DEjTByXGmIsGbWAYCgx0jySCTqBQgXwlEKhOTi1094CmsfBaEYjlDhoX1TQPJIJeZFSedrnA0pdSEg/7Qu70YxGMA5oHkS0zmgAzGuOn1SY2osAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/list.png
// module id = 74/z
// module chunks = 1